import React from 'react';
import { Link } from 'react-router-dom';

export default function ConfidentialitePage() {
  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', paddingTop: '100px', paddingBottom: '4rem' }}>
      <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 1.5rem' }}>
        <div style={{ background: 'white', borderRadius: '16px', padding: '3rem', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--blue-dark)', marginBottom: '0.5rem' }}>
            POLITIQUE DE CONFIDENTIALITÉ
          </h1>
          <p style={{ color: 'var(--gray-text)', fontSize: '0.85rem', marginBottom: '2.5rem' }}>
            Dernière mise à jour : Mars 2026
          </p>

          <Section title="1. Données collectées">
            Lors de votre inscription et utilisation de la plateforme ELIM DEPANNAGE, nous collectons les données suivantes :
            <ul>
              <li>Informations d'identité : nom, prénom, email, numéro de téléphone</li>
              <li>Localisation : ville, quartier, adresse</li>
              <li>Photo de profil (optionnelle)</li>
              <li>Pour les prestataires : photo du CIP, numéros Mobile Money, spécialités</li>
              <li>Données de navigation : pages visitées, appareil utilisé</li>
            </ul>
          </Section>

          <Section title="2. Utilisation des données">
            Vos données sont utilisées pour :
            <ul>
              <li>Créer et gérer votre compte</li>
              <li>Mettre en relation clients et prestataires</li>
              <li>Traiter les paiements via Mobile Money</li>
              <li>Envoyer des notifications et confirmations par email/SMS</li>
              <li>Améliorer nos services et l'expérience utilisateur</li>
              <li>Vérifier l'identité des prestataires</li>
            </ul>
          </Section>

          <Section title="3. Protection des données">
            <ul>
              <li>Toutes les données sont stockées sur des serveurs sécurisés.</li>
              <li>Les mots de passe sont cryptés et jamais stockés en clair.</li>
              <li>Les transactions sont sécurisées par protocole SSL 256-bit.</li>
              <li>Seuls les employés autorisés ont accès à vos données personnelles.</li>
            </ul>
          </Section>

          <Section title="4. Partage des données">
            Nous ne vendons jamais vos données personnelles à des tiers. Vos données peuvent être partagées uniquement dans les cas suivants :
            <ul>
              <li>Avec les prestataires/clients dans le cadre d'une mise en relation</li>
              <li>Avec nos partenaires de paiement (MTN, Moov, Celtiis) pour les transactions</li>
              <li>Sur demande des autorités judiciaires béninoises</li>
            </ul>
          </Section>

          <Section title="5. Vos droits">
            Vous avez le droit de :
            <ul>
              <li>Accéder à vos données personnelles</li>
              <li>Modifier vos informations depuis votre profil</li>
              <li>Demander la suppression de votre compte et de vos données</li>
              <li>Vous opposer à certains traitements de vos données</li>
            </ul>
            Pour exercer ces droits, contactez-nous à : <a href="mailto:elimdepannage@gmail.com" style={{ color: 'var(--orange)' }}>elimdepannage@gmail.com</a>
          </Section>

          <Section title="6. Cookies">
            Notre plateforme utilise des cookies pour maintenir votre session de connexion et améliorer votre expérience. Vous pouvez désactiver les cookies dans les paramètres de votre navigateur, mais cela peut affecter le fonctionnement de la plateforme.
          </Section>

          <Section title="7. Contact">
            Pour toute question relative à votre vie privée : <a href="mailto:elimdepannage@gmail.com" style={{ color: 'var(--orange)' }}>elimdepannage@gmail.com</a>
          </Section>

          <div style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--gray-mid)' }}>
            <Link to="/" style={{ color: 'var(--orange)', fontWeight: 600 }}>← Retour à l'accueil</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '2rem' }}>
      <h2 style={{ fontFamily: 'var(--font-cond)', fontSize: '1.1rem', color: 'var(--blue-dark)', marginBottom: '0.8rem', textTransform: 'uppercase', letterSpacing: '1px' }}>{title}</h2>
      <div style={{ color: '#444', lineHeight: 1.8, fontSize: '0.95rem' }}>{children}</div>
    </div>
  );
}
